import React from 'react';

import {useMediaQueries} from 'presentation/pages';
import {StyledSnackbar} from './styles';
import {CustomSnackbarProps} from './types';

export function Snackbar({color, ...snackbarProps}: CustomSnackbarProps) {
	const {isTablet} = useMediaQueries();

	return (
		<StyledSnackbar
			anchorOrigin={{vertical: 'bottom', horizontal: isTablet ? 'center' : 'right'}}
			autoHideDuration={4000}
			$color={color}
			{...snackbarProps}
		/>
	);
}
